import React, { useState, useEffect } from "react";
import Spinner from "../../reusables/spinner";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";
import Dropdown from "../../reusables/dropdown";
import InputField from "../../reusables/input";
import DeleteModal from "../../modals/deleteModal";
import EditCustomerModal from "../../modals/editCustomerModal";
import SuspendUser from "../../modals/suspendModal";
import { connect } from "react-redux";
import {
  fetch_approved_customers,
  search_approved_customers,
} from "../../../redux/actions/adminActions";
import UnSuspendModal from "../../modals/unSuspendModal";
import { periods, user_status } from "../../../utils/options";
import Pagination from "../../reusables/pagination";

function Allcustomers({
  next,
  searchApprovedCustomers,
  approvedCustomers,
  getApprovedCustomers,
  accessToken,
}) {
  const [loading, setLoading] = useState(true);
  let token = accessToken;

  let filters = ["first_name", "last_name", "phone", "email"];

  useEffect(() => {
    setLoading(true);
    getApprovedCustomers({ token, success });
  }, [getApprovedCustomers, accessToken]);

  const [customers, setCustomers] = useState(approvedCustomers);

  const [hasFilter, setFilter] = useState(false);

  const [filter, setFilters] = useState(filters[0]);

  const [optionsActive, setOptions] = useState(null);

  const [edit, setEdit] = useState({ modal: false, user: null });

  const [suspendUser, setSuspend] = useState({ modal: false, users: [] });

  const [unsuspendUser, setUnsuspend] = useState({ modal: false, users: [] });

  const [deleteUser, setDelete] = useState({ modal: false, users: [] });
  const [selectedCustomers, setSelected] = useState([]);
  let params = {};

  const [selectedTime, setTime] = useState("All dates");
  const handleSelectTime = (Item) => {
    setTime(Item);
    setLoading(true);
    let filter = Item;
    params = { ...params, ...{ filter: Item } };
    getApprovedCustomers({ token, success, params });
  };

  const success = () => {
    setLoading(false);
  };

  const [selectedStatus, setStatus] = useState("Status");

  const handleFilter = (item) => {
    setStatus(item);
    setLoading(true);
    params = { ...params, ...{ status: item } };
    getApprovedCustomers({ token, success, params });
  };

  const handleOptions = (id) => {
    if (optionsActive === null) {
      setOptions(id);
    } else {
      setOptions(null);
    }
  };

  const [suggestions, setSuggest] = useState([]);

  const [search, setSearch] = useState("");

  const searchHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    searchApprovedCustomers(accessToken, filter, search, success);
  };

  const handleSuspend = (id) => {
    setSuspend({
      ...suspendUser,
      modal: true,
      users: [...suspendUser.users, id],
    });
  };

  const handleUnsuspend = (id) => {
    setUnsuspend({
      ...unsuspendUser,
      modal: true,
      users: [...unsuspendUser.users, id],
    });
  };

  const handleSelect = (e) => {
    let updatedList = [...selectedCustomers];
    if (e.target.checked) {
      updatedList = [...selectedCustomers, Number(e.target.value)];
    } else {
      updatedList.splice(selectedCustomers.indexOf(e.target.value), 1);
    }
    setSelected(updatedList);
  };

  const handleSuggestions = (e) => {
    let results = [];

    setSuggest(results);
    setSearch(e.target.value.toLowerCase());

    approvedCustomers.data.map((item) => {
      switch (filter) {
        case "first_name":
          let fname_matches = item?.first_name?.match(
            e.target.value.toLowerCase()
          );
          if (fname_matches && results.length < 3) {
            results.push(fname_matches?.input);
          }

          break;

        case "last_name":
          let lname_matches = item?.last_name?.match(
            e.target.value.toLowerCase()
          );
          if (lname_matches && results.length < 3) {
            results.push(lname_matches?.input);
          }
          break;

        case "phone":
          let phone_matches = item?.phone.match(e.target.value.toLowerCase());
          if (phone_matches && results.length < 3) {
            results.push(phone_matches?.input);
          }
          break;

        case "email":
          let email_matches = item?.email.match(e.target.value.toLowerCase());
          if (email_matches && results.length < 3) {
            results.push(email_matches?.input);
          }
          break;

        default:
          break;
      }
    });
    
  };

  const resetSearch = () => {
    setSearch("");
    setLoading(true);
    getApprovedCustomers({ token, success });
  };

  const onPageChange = (page) => {
    setLoading(true);
    params = { ...params, ...{ page: page } };
    getApprovedCustomers({ token, success, params });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween mobileBlock">
          <div className="searchHolder isRelative ">
            <div className="alignOnly">
              <Dropdown value={filter} className="mx-1">
                {filters.map((item) => (
                  <div
                    className="isClickable hoverGreen"
                    onClick={() => setFilters(item)}
                  >
                    <p className="sectionText px-3 py-2 mb-0">{item}</p>
                  </div>
                ))}
              </Dropdown>
              <InputField
                inputClass="mx-1"
                iconClick={searchHandler}
                value={search}
                onChange={handleSuggestions}
                placeholder={`Search by ${filter}`}
                icon
                iconClass="ri-search-line"
              />

              {search !== "" && (
                <span
                  className="isRed sectionText--small mx-2 isClickable"
                  onClick={resetSearch}
                >
                  Clear Filter
                </span>
              )}
            </div>

            {suggestions?.length > 0 && (
              <div className="suggestions_holder isRelative">
                <div className="suggestions">
                  {suggestions?.map((item) => (
                    <div
                      className="isClickable hoverGreen"
                      onClick={() => {
                        setSearch(item);
                        setSuggest([]);
                      }}
                    >
                      <p className="sectionText px-3 py-2 mb-0">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="alignOnly pt-2">
            <button
              className={`btn__filled ${
                !selectedCustomers.length > 0 && "btn__disabled"
              } hasRadius mx-1`}
              disabled={!selectedCustomers.length > 0}
              onClick={() => {
                setSuspend({ modal: true, users: selectedCustomers });
              }}
            >
              Suspend
            </button>

            <button
              className={`btn__red ${
                !selectedCustomers.length > 0 && "btn__disabled"
              } hasRadius mx-1`}
              disabled={!selectedCustomers.length > 0}
              onClick={() => {
                setDelete({
                  modal: true,
                  users: [...deleteUser.users, ...selectedCustomers],
                });
              }}
            >
              Delete
            </button>

            <Dropdown value={selectedTime} className="mx-1">
              {periods?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleSelectTime(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>

            <Dropdown value={selectedStatus} className="mx-1">
              {/* <div
                className="isClickable hoverGreen"
                onClick={() => {
                  setStatus("All");
                  setFilter(false);
                }}
              >
                <p className="sectionText px-3 py-2 mb-0">All</p>
              </div> */}
              {user_status?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleFilter(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
          </div>
        </div>

        <div className="fulleight scrollable py-5">
          {hasFilter ? (
            customers?.length > 0 ? (
              <table className="table">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Name</th>
                    <th className="vAlign">Mobile</th>
                    <th className="vAlign">Email</th>
                    <th className="vAlign">Address</th>
                    <th className="vAlign">Date</th>
                    <th className="vAlign">ID Type</th>
                    <th className="vAlign">ID Number</th>
                    <th className="vAlign">Status</th>
                    <th className="vAlign">Action</th>
                  </tr>
                </thead>
                <tbody className="">
                  {customers?.map((item) => (
                    <tr className="hasRadius">
                      <td className="alignOnly">
                        <input
                          type="checkbox"
                          className="isClickable"
                          value={item.id}
                          onChange={handleSelect}
                          id=""
                        />

                        <div className="mx-1 alignOnly">
                          <div className="supplier__image mx-2">
                            <img
                              src={item.display_pic}
                              className="w-100"
                              alt=""
                            />
                          </div>

                          <p className="mb-0 textIsBold sectionText">
                            {item.first_name + " " + item.last_name}
                          </p>
                        </div>
                      </td>

                      <td className="pt-4 vAlign">
                        <p className="mb-0  sectionText">{item.phone}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0 sectionText">{item.email}</p>
                      </td>

                      <td className="vAlign pt-4 address">
                        <p className="mb-0 sectionText">{item.address}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">{item.date}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">{item.id_type}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">{item.id_number}</p>
                      </td>

                      <td className="center pt-3">
                        <div
                          className={`tag ${
                            item.status === "active" ? "done" : "pending"
                          }`}
                        >
                          {item.status}
                        </div>
                      </td>

                      <td className="vAlign pt-4">
                        <i
                          class="ri-more-line isClickable"
                          onClick={() => handleOptions(item.id)}
                        ></i>

                        {optionsActive === item?.id && (
                          <div className="options">
                            <div className="caret"></div>
                            <div className="p-2 textIsBold lAlign sectionText--small">
                              <div
                                className="hasBorder--bottom py-2"
                                onClick={() =>
                                  setEdit({
                                    ...edit,
                                    modal: true,
                                    user: item,
                                  })
                                }
                              >
                                Edit
                              </div>
                              <div
                                className="hasBorder--bottom pt-2 pb-2"
                                onClick={
                                  item.status === "active"
                                    ? handleSuspend(item.id)
                                    : handleUnsuspend(item.id)
                                }
                              >
                                {item?.status === "active"
                                  ? "Suspend"
                                  : "Unsuspend"}
                              </div>
                              <div
                                className="isRed pt-2 pb-2"
                                onClick={() =>
                                  setDelete({
                                    ...deleteUser,
                                    modal: true,
                                    users: [...deleteUser.users, item.id],
                                  })
                                }
                              >
                                Delete
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="w-100 sectionHeight--mid pt-4">
                <h2 className="sectionHead--small textIsBold textIsGreen">
                  No customer found
                </h2>
              </div>
            )
          ) : !loading ? (
            approvedCustomers?.data?.length > 0 ? (
              <table className="table">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Name --</th>
                    <th className="vAlign">Mobile</th>
                    <th className="vAlign">Email</th>
                    <th className="vAlign">Address</th>
                    <th className="vAlign">Date</th>
                    <th className="vAlign">ID Type</th>
                    <th className="vAlign">ID Number</th>
                    <th className="vAlign">Status</th>
                    <th className="vAlign">Action</th>
                  </tr>
                </thead>
                <tbody className="">
                  {approvedCustomers?.data.map((item) => (
                    <tr className="hasRadius">
                      <td className="alignOnly">
                        <input
                          type="checkbox"
                          className="isClickable"
                          value={item.id}
                          onChange={handleSelect}
                          id=""
                        />

                        <div className="mx-1 alignOnly">
                          <div className="supplier__image mx-2">
                            <img
                              src={item.display_pic}
                              className="w-100"
                              alt=""
                            />
                          </div>

                          <p className="mb-0 textIsBold sectionText">
                            {item.first_name + " " + item.last_name}
                          </p>
                        </div>
                      </td>

                      <td className="pt-4 vAlign">
                        <p className="mb-0  sectionText">{item.phone}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0 sectionText">{item.email}</p>
                      </td>

                      <td className="vAlign pt-4 address">
                        <p className="mb-0 sectionText">{item.address}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">{item.date}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">{item.id_type}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">{item.id_number}</p>
                      </td>

                      <td className="center pt-3">
                        <div
                          className={`tag ${
                            item.status === "active" ? "done" : "pending"
                          }`}
                        >
                          {item.status}
                        </div>
                      </td>

                      <td className="vAlign pt-4">
                        <i
                          class="ri-more-line isClickable"
                          onClick={() => handleOptions(item.id)}
                        ></i>

                        {optionsActive === item.id && (
                          <div className="options">
                            <div className="caret"></div>
                            <div className="p-2 textIsBold lAlign sectionText--small">
                            <div
                                className="hasBorder--bottom py-2"
                                onClick={() =>
                                  next(item.id, item?.first_name +" "+item?.last_name)
                                }
                              >
                                View
                              </div>
                              {/* <div
                                className="hasBorder--bottom pb-2"
                                onClick={() =>
                                  setEdit({
                                    ...edit,
                                    modal: true,
                                    user: item,
                                  })
                                }
                              >
                                View
                              </div> */}
                              <div
                                className="hasBorder--bottom pt-2 pb-2"
                                onClick={() =>
                                  setEdit({
                                    ...edit,
                                    modal: true,
                                    user: item,
                                  })
                                }
                              >
                                Edit
                              </div>
                              <div
                                className="hasBorder--bottom pt-2 pb-2"
                                onClick={
                                  item.status === "active"
                                    ? () => handleSuspend(item.id)
                                    : () => handleUnsuspend(item.id)
                                }
                              >
                                {item?.status === "active"
                                  ? "Suspend"
                                  : "Unsuspend"}
                              </div>
                              <div
                                className="isRed pt-2 pb-2"
                                onClick={() =>
                                  setDelete({
                                    ...deleteUser,
                                    modal: true,
                                    users: [...deleteUser.users, item.id],
                                  })
                                }
                              >
                                Delete
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="w-100 sectionHeight--mid center pt-4">
                <h2 className="sectionHead--small textIsBold textIsGreen">
                  No customer found
                </h2>
              </div>
            )
          ) : (
            <Spinner big />
          )}
          <div className="d-flex justify-content-end">
            <Pagination
              onChange={onPageChange}
              page={approvedCustomers?.current_page}
              total={approvedCustomers?.total}
              per_page={approvedCustomers?.per_page}
            />
          </div>
        </div>
      </div>

      <EditCustomerModal
        user={edit.user}
        show={edit.modal}
        handleClose={() =>
          setEdit({
            ...edit,
            modal: false,
          })
        }
      />

      <DeleteModal
        users={deleteUser.users}
        show={deleteUser.modal}
        handleClose={() =>
          setDelete({
            ...deleteUser,
            modal: false,
          })
        }
      />

      <SuspendUser
        customer
        show={suspendUser.modal}
        users={suspendUser.users}
        handleClose={() =>
          setSuspend({
            ...suspendUser,
            modal: false,
          })
        }
      />

      <UnSuspendModal
        customer
        show={unsuspendUser.modal}
        users={unsuspendUser.users}
        handleClose={() =>
          setUnsuspend({
            ...unsuspendUser,
            modal: false,
          })
        }
      />
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  approvedCustomers: state.admin.customers.approved,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getApprovedCustomers: (token, success) =>
    dispatch(fetch_approved_customers(token, success)),
  searchApprovedCustomers: (token, type, value, success) =>
    dispatch(search_approved_customers(token, type, value, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Allcustomers);
